import { RouteObject } from "react-router-dom";
import CertDetails from "../pages/CertDetails"; 

const RFSICRoutes: RouteObject = {
  path: "rfsic",
  children: [
    {
      path: "check/FS251",
      element: <CertDetails />,
    },
    
  ]
};

export default RFSICRoutes;
